import { useNotify, useTranslate } from 'react-admin';
import { useCallback } from 'react';

const KNOWN_ERROR_CODES = [
  'CANNOT_DELETE_DEFAULT_QUEUE',
  'CANNOT_DELETE_LAST_QUEUE',
  'CANNOT_DELETE_QUEUE_WITH_ACTIVE_TICKETS',
  'CANNOT_UNSET_DEFAULT_QUEUE',
] as const;

type ErrorResponse = {
  errorCode?: string;
  message?: string;
  activeTicketsCount?: number;
};

export const useTicketQueueErrorHandler = (
  fallbackKey: 'deleteFailed' | 'updateFailed',
) => {
  const notify = useNotify();
  const translate = useTranslate();

  return useCallback(
    (error: unknown) => {
      const errorObj = error as {
        body?: ErrorResponse;
        message?: string;
      };
      const errorResponse = errorObj?.body || {};
      const errorCode = errorResponse.errorCode;

      if (
        errorCode &&
        KNOWN_ERROR_CODES.includes(errorCode as (typeof KNOWN_ERROR_CODES)[number])
      ) {
        notify(
          translate(`resources.ticket-queue.errors.${errorCode}`, {
            activeTicketsCount: errorResponse.activeTicketsCount ?? 0,
          }),
          { type: 'error' },
        );
      } else {
        const message =
          errorResponse.message ||
          errorObj?.message ||
          translate(`resources.ticket-queue.errors.${fallbackKey}`);
        notify(message, { type: 'error' });
      }
    },
    [notify, translate, fallbackKey],
  );
};
